import ResumeContentComponent from "./ResumeContent";

export default ResumeContentComponent;
